import React, { Suspense } from 'react'
import './App.css'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import '../src/components/utils/loading/loading.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Modal } from 'react-bootstrap'

const Access = React.lazy(() => import('./components/access/access'))
const Navbar = React.lazy(() => import('./components/navbar/navbar'))

function App() {

  return (<>
    <div className="demo-msg">
      This is a demo version, the information is fictitious and no actions performed will be stored.
    </div>
    <Router>
      <Suspense fallback={<div>
        <Modal
          className="modal-container modal-loading"
          show={true}
          backdrop="static"
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="d-flex justify-content-center spinner">
              <span className="icon-spinner">
                <FontAwesomeIcon icon={faSpinner} />
              </span>
            </div>
            <div className="row text-center">
              <span className="loading-text">Loading</span>
              <small>Plase wait, while the information is proccesing.</small>
            </div>
          </Modal.Body>
        </Modal>
      </div>}>
        <Switch>
          <Route path="/" exact component={Navbar} />
          <Route path="/login" exact component={Access} />
          <Redirect to="/" />
        </Switch>
      </Suspense>
    </Router>
  </>)
}

export default App
